import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  padding: 15px 10px;
  position: absolute;
  bottom: 0;

  ul {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      & + li {
        border-left: 1px solid #c5c5c5;
        padding-left: 10px;
      }

      margin: 0 5px;
      height: 10px;
      display: flex;
      align-items: center;

      span {
        font-size: 1.4rem;
        color: #c5c5c5;
      }

      a {
        font-size: 1.4rem;
        color: #c5c5c5;
        text-decoration: none;
      }
    }
  }

  @media (max-width: 660px) {
    ul {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;

      li {
        border-right: none;
        margin: 5px;
      }
    }
  }
`;
